import { Link } from "react-router-dom";
import { TOPICS } from "@/data/topics";
import Reveal from "./Reveal";

export default function HelpTopics() {
  return (
    <section className="bg-[#C8F000] border-y-4 border-tpeco-ink py-16 sm:py-20" data-testid="help-topics-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <Reveal>
          <h2 className="font-display uppercase text-5xl sm:text-6xl leading-[0.95] text-tpeco-blue" data-testid="help-topics-heading">
            SOMETHING ELSE?<br />WE CAN HELP!
          </h2>
        </Reveal>
        <div className="mt-10 flex flex-col items-center gap-4">
          {TOPICS.map((t, i) => (
            <Reveal key={t.slug} i={i} className="w-full flex justify-center">
              <Link to={`/${t.slug}`} className="btn-brutal w-full max-w-md !text-xl" data-testid={`help-topic-${t.slug}`}>
                {t.label}
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
